import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';

document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('brand', '.logos-container');
  displayBrandSliderOnLoad();
  getSVG();
});
